export default [
  {
    title: 'Contacto',
    route: 'contacto',
    icon: 'EditIcon',
  },
]
